import { LightWeightObjectChangeTracker, getAllLeafPaths, shakeDeadLeaves } from '@schoolbelle/common/object-change-tracker';
import { unset } from 'lodash';
 
export class Reply extends LightWeightObjectChangeTracker {

    updateDiff () {
        super.updateDiff();
        getAllLeafPaths(this.to).forEach(path=>{
            if (path.split('.').length === 4 && path.split('.').pop() === 'id') unset(this.to, path);
        })
        this.to = shakeDeadLeaves(this.to);
        getAllLeafPaths(this.from).forEach(path=>{
            if (path.split('.').length === 4 && path.split('.').pop() === 'id') unset(this.from, path);
        })
        this.from = shakeDeadLeaves(this.from);

    }
}
